import "@/App.css";

function App() {
  return (
    <div className="App" style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
      <iframe
        title="CoreHospitality Hub"
        src={"/standalone.html" + window.location.search}
        data-testid="hub-iframe"
        allow="camera; microphone"
        style={{ width: "100%", height: "100%", border: "none", display: "block" }}
      />
    </div>
  );
}

export default App;
